module.exports = __webpack_public_path__ + "static/media/default-profile-picture.154ab421.png";